export const DEFAULT_DEVICE_PROJECT_NAME = 'App';
